import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[var(--at-bg)] text-[var(--at-navy)]">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="light"
          richColors
          toastOptions={{
            classNames: {
              toast:
                "!rounded-2xl !border !border-[var(--at-border)] !bg-[var(--at-bg)] !text-[var(--at-navy)] !font-sans",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
